import { State } from './vuex'
import { find, get } from 'lodash'
import moment from 'moment'
import { mapping } from './page_meta_event'

function getCruiseName(state: State, url: string) {
  return get(state, url, 'n/a')
}

export function buildCruiseName(state: State) {
  let cruise = getCruiseName(state, 'booking.general.cruise.name')
  let duration = getDuration(state, 'booking.general.cruise.duration')
  let shipName = getShipName(state, 'booking.general.cruise.shipName')
  let startDate = get(state, 'booking.general.cruise.departure')
  let endDate = get(state, 'booking.general.cruise.arrival')
  return `${cruise} ${duration} Tage mit ${shipName}, ${startDate} bis ${endDate}`
}

export function getCruiseId(state: State, url: string) {
  return get(state, url, 'n/a')
}

export function getShipName(state: State, url: string) {
  return get(state, url, 'n/a')
}

export function getDeparturePortNameInCheckout(state: State) {
  return get(state, 'booking.general.cruise.departureStationName', 'n/a')
}

export function getArrivalPortNameInCheckout(state: State) {
  return get(state, 'booking.general.cruise.arrivalStationName', 'n/a')
}

export function getDestination(state: State, url: string) {
  var destination = get(state, url)

  if (destination == 'VRXX') return 'n/a'

  return get(state, url)
}

export function getStartDate(state: State, url: string) {
  const startDateString = get(state, url, 'n/a')

  if (!startDateString || startDateString == 'n/a') {
    return startDateString
  }
  return startDateString
    .split('.')
    .reverse()
    .join('-')
    .toString()
}

export function getEndDate(state: State, url: string) {
  const endDateString = get(state, url, 'n/a')

  if (!endDateString || endDateString == 'n/a') {
    return endDateString
  }
  return endDateString
    .split('.')
    .reverse()
    .join('-')
    .toString()
}

export function getDuration(state: State, url: string) {
  return get(state, url, 'n/a').toString()
}

export function getDaysToCruise(state: State, url: string) {
  const startDateString = get(state, url, 'n/a')

  if (!startDateString || startDateString == 'n/a') {
    return startDateString
  }
  const isoString = startDateString
    .split('.')
    .reverse()
    .join('-')

  const start = moment(isoString)
  const now = moment()

  return Math.floor(moment.duration(start.diff(now)).asDays()).toString()
}

export function getMandatoryFlight(state: State, url: string, priceModelUrl: string) {
  const mandatoryFlights = get(state, url, 'n/a')
  const priceModel = get(state, priceModelUrl, 'n/a')
  return mandatoryFlights[priceModel] === true ? 'yes' : 'no'
}

export function getAge(birthDate: string) {
  const birtdayDate = new Date(birthDate)
  var month_diff = Date.now() - birtdayDate.getTime()
  var age_dt = new Date(month_diff)
  var year = age_dt.getUTCFullYear()
  return Math.abs(year - 1970)
}

export function findStepIndex(path: string): number {
  for (const pageCategory of mapping) {
    if (pageCategory.category === 'checkout') {
      for (let i = 0; i < pageCategory.pages.length; i++) {
        if (pageCategory.pages[i].regex.test(path)) {
          return i
        }
      }
    }
  }
  return -1
}